import {
  ApiErrorResponse,
  ApiErrorResponseError,
  AppErrorType,
} from '../errors'

export const getErrorFromApiResponse = (
  response: ApiErrorResponse
): ApiErrorResponseError | null => {
  if (!response) return null

  if (
    //@ts-ignore
    process.env.ENV !== 'prod' &&
    response.internalErrors &&
    response.internalErrors.length
  ) {
    return {
      message: `${response.errors[0].message} - ${response.internalErrors[0].message}`,
      type: response.errors[0].type,
    }
  }

  if (response.errors && response.errors.length) return response.errors[0]

  return {
    message: 'Error',
    type: null,
  }
}

export const getErrorTypeFromApiResponse = (
  response: ApiErrorResponse
): AppErrorType | null => {
  if (!response) return null

  if (response.errors && response.errors.length)
    return response.errors[0].type as AppErrorType

  return null
}

function getHttpStatus(error: unknown): number | null {
  if (!error || typeof error !== 'object') return null

  const status = (error as { status?: unknown }).status

  return typeof status === 'number' ? status : null
}

export const isAuthenticationError = (error: unknown): boolean =>
  getHttpStatus(error) === 401

export const isForbiddenError = (error: unknown): boolean =>
  getHttpStatus(error) === 403
